/**
 * The price list every country page's table prints: the Proxy Server list,
 * kept once in the CMS (`priceList`) and printed by every table that lists
 * it, as Webflow's pages printed its "Price Proxy Servers" collection.
 */
export const COUNTRY_PRICE_LIST = "priceList-proxy-server";
